<template>
   <section
      v-if="currentClass"
      :class="[
         'class-hero',
         `class-${currentClass?.discipline?.slug}`,
         { archived: currentClass?.archived },
      ]"
   >
      <Image
         :image="currentClass.image"
         v-if="currentClass.image?.src"
         fit="cover"
         :key="currentClass.image?.src"
      />

      <div class="text">
         <h2 v-if="currentClass?.title" class="title">
            {{ currentClass.title }}
         </h2>
         <div class="meta">
            <div v-if="user?.school?.name" class="meta-item">
               <p class="label grey">School</p>
               <p class="item">{{ user.school.name }}</p>
            </div>
            
         </div>
      </div>
   </section>
</template>

<script setup lang="ts">
const { user } = useAuthStore();
const classesStore = useClassesStore();
const { currentClass } = storeToRefs(classesStore);
</script>

<style lang="scss">
@import "~/assets/scss/classes/class-hero";
</style>
